module.exports = __webpack_public_path__ + "img/mobrightimage.fab48b22.svg";